module.exports = __webpack_public_path__ + "img/download-icon.35400621.svg";